import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";
import { Beer, BeerFlight } from "../data/types";

const beersRef = collection(db, "beers");

export const getBeers = async () => {
  const querySnapshot = await getDocs(beersRef);
  const beers: any[] = [];

  querySnapshot.forEach((doc) => {
    beers.push({ id: doc.id, ...doc.data() });
  });

  const sorted = beers.sort((a, b) => a.order - b.order);

  return sorted;
};

export const getRecentBeerFlight = async (): Promise<BeerFlight | null> => {
  const q = query(
    collection(db, "beerFlights"),
    orderBy("createdAt", "desc"),
    limit(1)
  );

  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    return querySnapshot.docs[0].data() as BeerFlight;
  }

  return null;
};

// ----------- ADMIN -----------

export const createBeerFlight = async (flight: {
  name?: string;
  description?: string;
  beers: (Beer | null)[];
}) => {
  if (flight.beers.length !== 5) throw new Error("Exakt 5 öl krävs.");

  const docRef = await addDoc(collection(db, "beerFlights"), {
    ...flight,
    createdAt: Timestamp.now(),
  });

  return docRef.id;
};

export const addBeer = async (beer: Beer) => {
  try {
    const docRef = await addDoc(beersRef, {
      name: beer.name,
      abv: beer.abv,
      image: beer.image,
      untappdLink: beer.untappdLink,
      type: beer.type,
      availability: beer.availability,
      description: beer.description ? beer.description : "",
      funFact: beer.funFact ? beer.funFact : "",
      order: beer.order ?? 1000,
      available: beer.available !== false,
    });
    console.log("Beer added with ID:", docRef.id);
  } catch (error) {
    console.error("Error adding beer: ", error);
  }
};

export const updateBeer = async (beer: Beer) => {
  try {
    if (!beer.id) return;

    const beerDoc = doc(db, "beers", beer.id);
    await updateDoc(beerDoc, {
      name: beer.name,
      abv: beer.abv,
      image: beer.image,
      type: beer.type,
      availability: beer.availability,
      untappdLink: beer.untappdLink,
      funFact: beer.funFact,
      description: beer.description,
      available: beer.available !== false,
    });
    console.log("Beer updated:", beer.id);
  } catch (error) {
    console.error("Error updating beer: ", error);
  }
};

export const updateBeerOrder = async (beerId: string, order: number) => {
  try {
    const beerDoc = doc(db, "beers", beerId);
    await updateDoc(beerDoc, {
      order: order,
    });
    console.log("Beer order updated:", beerId);
  } catch (error) {
    console.error("Error updating beer order: ", error);
  }
};

export const deleteBeer = async (beerId: string) => {
  try {
    const beerDoc = doc(db, "beers", beerId);
    await deleteDoc(beerDoc);
    console.log("Beer deleted:", beerId);
  } catch (error) {
    console.error("Error deleting beer: ", error);
  }
};
